import i18n from '@/plugins/i18n'

export const extractClapError = (e: ClapError): string => {
  if (e?.response?.data?.clapErr?.[i18n.global.locale.value]) {
    return e?.response?.data?.clapErr?.[i18n.global.locale.value]
  }
  return i18n.global.t('Something went wrong')
}
